import { Injectable } from '@angular/core';
import { UrlEnum } from '../../enum/url.enum';
import { UtilitiesService } from '../utilities/utilities.service';
import { HttpRequestService } from '../http-request/http-request.service';
import { map, Observable } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class DonorCrmService {
  private donorCrmApi = `${UrlEnum.SHOHAY_NGO}/donor-crm`;

  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly httpRequestService: HttpRequestService,
    private readonly localStorageService: LocalStorageService
  ) {}

  public getDonorCrmDashboard(): Observable<any> {
    const localNgoId = this.localStorageService.getNgoInLocalStorage().id;
    const url = `${this.donorCrmApi}/${
      this.localStorageService.getIsNgoAdmin() ? 'ngo-admin' : 'shohay-admin'
    }/`;

    return this.httpRequestService
      .get(`${url}get-dashboard-summary/${localNgoId}`)
      .pipe(
        map((response: any) => this.utilitiesService.responseHandler(response))
      );
  }

  public getDonorCrmDashboardActivity(
    start_date: string,
    end_date: string,
    status?: string,
    ngoId?: string,
    campaignIds?: string[]
  ): Observable<any> {
    let url: string = null;
    if (!ngoId) {
      const localNgoId = this.localStorageService.getNgoInLocalStorage().id;
      url = `${this.donorCrmApi}/${
        this.localStorageService.getIsNgoAdmin() ? 'ngo-admin' : 'shohay-admin'
      }/get-donor-activity?${localNgoId}&ngo_id=${localNgoId}&start_date=${start_date}&end_date=${end_date}`;
    } else {
      url = `${this.donorCrmApi}/${
        this.localStorageService.getIsNgoAdmin() ? 'ngo-admin' : 'shohay-admin'
      }/get-donor-activity?${ngoId}&ngo_id=${ngoId}&start_date=${start_date}&end_date=${end_date}`;
    }

    if (status) {
      url += `&status=${status}`;
    }

    if (campaignIds) {
      url += `&campaign_ids=${campaignIds.join(',')}`;
    }

    return this.httpRequestService
      .get(url)
      .pipe(
        map((response: any) => this.utilitiesService.responseHandler(response))
      );
  }

  public getDonorCrmManagementDashboard(): Observable<any> {
    const localNgoId = this.localStorageService.getNgoInLocalStorage().id;
    return this.httpRequestService
      .get(
        `${UrlEnum.SHOHAY_NGO}/donor-crm/ngo-admin/get-management-dashboard/${localNgoId}`
      )
      .pipe(
        map((response: any) => this.utilitiesService.responseHandler(response))
      );
  }

  public getDonorCrmProfile(ngo_id: string, donorId: string): Observable<any> {
    const localNgoId = this.localStorageService.getNgoInLocalStorage().id;

    return this.httpRequestService
      .get(
        `${UrlEnum.SHOHAY_NGO}/donor-crm/${
          this.localStorageService.getIsNgoAdmin()
            ? 'ngo-admin'
            : 'shohay-admin'
        }/get-donor-profile/${localNgoId}/${donorId}`
      )
      .pipe(
        map((response: any) => this.utilitiesService.responseHandler(response))
      );
  }

  public getAllDonorCrmManagement(
    start_date: string,
    end_date: string
  ): Observable<any> {
    const localNgoId = this.localStorageService.getNgoInLocalStorage().id;
    const url = `${this.donorCrmApi}/${
      this.localStorageService.getIsNgoAdmin() ? 'ngo-admin' : 'shohay-admin'
    }/`;

    return this.httpRequestService
      .get(
        `${url}get-donor-list?${localNgoId}&ngo_id=${localNgoId}&start_date=${start_date}&end_date=${end_date}`
      )
      .pipe(
        map((response: any) => this.utilitiesService.responseHandler(response))
      );
  }

  public getTopDonors(): Observable<any> {
    const localNgoId = this.localStorageService.getNgoInLocalStorage().id;
    return this.httpRequestService
      .get(
        `${UrlEnum.SHOHAY_NGO}/ngo-donation/ngo-top-donor/get-by-ngo/${localNgoId}?limit=10`
      )
      .pipe(
        map((response: any) => this.utilitiesService.responseHandler(response))
      );
  }
}
